import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import { isNumber } from 'utilities/validators';

import Input from 'components/Input';

const CutoffFieldComponent = props =>
  <Field
    {...props}
    step={0.01}
    type="number"
    component={Input}
    validate={isNumber}

    labelClassName={`main-input__label mr-10 ${props.labelClass}`}
    inputClassName="main-input__input max-110"
    wrapperClassName="main-input--inline mb-15"
  />;

CutoffFieldComponent.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  labelClass: PropTypes.string.isRequired
};

export default CutoffFieldComponent;
